import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, ExternalLink } from "lucide-react";
import SEO, { articleJsonLd, breadcrumbJsonLd } from "../components/SEO";

export default function ArticleDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get(`/articles/${id}`).then(r => setA(r.data)).catch(() => {});
  }, [id]);

  if (!a) return <div className="max-w-3xl mx-auto p-12 text-center text-[#4B634B]">Chargement...</div>;

  const back = a.section === "wealth" ? "/healthy-guides" : "/kitchen-corner";
  const backLabel = a.section === "wealth" ? "Healthy Guides" : "Kitchen Corner";

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12 py-12" data-testid="article-detail">
      <SEO
        seo={a.seo || {}}
        title={a.title}
        description={a.excerpt}
        image={a.cover_image}
        path={`/article/${a.id}`}
        ogType="article"
        jsonLd={[
          articleJsonLd({ article: a, urlPath: `/article/${a.id}` }),
          breadcrumbJsonLd([
            { name: "Accueil", path: "/" },
            { name: backLabel, path: back },
            { name: a.title, path: `/article/${a.id}` },
          ]),
        ]}
      />
      <Link to={back} className="inline-flex items-center gap-2 text-sm text-[#4B634B] hover:text-[#7AC143] mb-6">
        <ArrowLeft className="w-4 h-4" /> Retour
      </Link>
      <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#7AC143] mb-3">
        {a.section === "wealth" ? "Healthy Guides" : "Kitchen Corner"}
      </div>
      <h1 className="text-4xl lg:text-5xl font-black tracking-tighter text-[#1A2E1A]">{a.title}</h1>
      <p className="mt-4 text-[#4B634B] text-lg">{a.excerpt}</p>
      <div className="text-xs text-[#4B634B] mt-3">Par {a.author} · {new Date(a.created_at).toLocaleDateString("fr-FR")}</div>
      <img src={a.cover_image} alt={a.title} className="w-full aspect-[16/9] object-cover rounded-3xl mt-8" />
      <div className="prose prose-lg max-w-none mt-10 text-[#1A2E1A] leading-relaxed whitespace-pre-wrap">
        {a.content}
      </div>
      {a.external_link && (
        <a href={a.external_link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-8 bg-[#7AC143] hover:bg-[#67BC2A] text-white rounded-full px-6 py-3 font-semibold" data-testid="article-external-link">
          <ExternalLink className="w-4 h-4" /> Ressource externe
        </a>
      )}
    </article>
  );
}
